import React, { Fragment } from 'react';
import format from 'date-fns/format';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { academicProgramsService } from '../../../../services';

const STATUS_BADGE_CLASS = {
    Submitted: 'badge-secondary',
    'Under Review': 'badge-primary',
    'Awaiting Institution': 'badge-warning',
    Approved: 'badge-success',
    Denied: 'badge-danger',
    Deleted: 'badge-dark',
};

const formatCreatedDate = createdDate => {
    if (createdDate == null) return <Fragment />;
    return <Fragment>{format(new Date(createdDate), 'M/d/yyyy')}</Fragment>;
};

export const RequestMetadataPanel = ({ details, onEditClick }) => {
    const badgeClass = STATUS_BADGE_CLASS[details.status] ?? 'badge-secondary';
    const canEdit =
        details.status === 'Submitted' || details.status === 'Awaiting Institution';

    return (
        <section className="request-metadata">
            <div className="request-content">
                <h2 className="text-strong mb-2">{details.programName}</h2>
                <h5 className="text-600 mb-4">{details.institutionName}</h5>
                <ul className="list-group list-group-flush bg-none">
                    <li className="list-group-item px-0">
                        <label className="text-muted text-600">Request Type</label>
                        <p className="m-0">{details.description}</p>
                    </li>
                    <li className="list-group-item px-0">
                        <label className="text-muted text-600">Requested On</label>
                        <p className="m-0">{formatCreatedDate(details.createdOn)}</p>
                    </li>
                    <li className="list-group-item px-0">
                        <label className="text-muted text-600">Status</label>
                        <p className="m-0">
                            <span className={`badge ${badgeClass}`}>{details.status}</span>
                        </p>
                    </li>
                    <li className="list-group-item px-0">
                        <label className="text-muted text-600">Supporting Documentation</label>
                        {details.requestAttachments?.map(file => (
                            <p
                                key={file.id}
                                className="m-0 text-primary"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    academicProgramsService.downloadAttachment(
                                        file.id,
                                        file.fileName
                                    )
                                }
                            >
                                {file.fileName}
                            </p>
                        ))}
                    </li>
                </ul>
            </div>
            {canEdit && (
                <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={onEditClick}
                >
                    <FontAwesomeIcon icon={faPencilAlt} /> Edit Program Request
                </button>
            )}
        </section>
    );
};
